const API_BASE = process.env.REACT_APP_API_BASE || 'http://localhost:8080/justingoffmusic/api';

export default API_BASE;